// import  axios  from 'axios';
import {Axios} from '../plugins/axios.js';


const state = {
}

const getters = {

}

const mutations =  {

}

const actions = {
  getManagementCommissionAndGender ({ commit, state }, payload) {
     const data   = payload.data;
     let page     = data.page;
     let url      = '';

     page += -1
     data.page = page;

     for (let content in data) {
       url+=`&${content}=${data[content]}`
     }

     return new Axios()
     .get(`biav/v1/admin/sans/table?${url}`)
     .then(response => {
       return response;
     })
     .catch(()=>{
       return 'error';
     })
  },

  updateManagementCommissionAndGender ({ commit, state }, payload) {
     const data   = payload.data;
     return new Axios()
     .post(`biav/v1/admin/sans/update`,data)
     .then(response => {
       return response;
     })
     .catch(()=>{
       return 'error';
     })
  },

  getHour ({ commit, state }, payload) {
     const data   = payload.data;

     return new Axios()
     .get(`biav/v1/admin/sans/hours?hall_id=${data.hall_id}`)
     .then(response => {
       return response;
     })
     .catch(()=>{
       return 'error';
     })
  },











}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
